<template>
  <div class="form-group">
    <h4>Payment method</h4>
    <label class="radio-head" id="pmt-cc">
      <input type="radio" class="pmt-type" @input="setAccountType(credit_card)" :checked="account_type === credit_card">
      <span>Credit card</span>
    </label>
    <label class="radio-head" id="pmt-ach">
      <input type="radio" class="pmt-type" @input="setAccountType(ach)" :checked="account_type === ach">
      <span>Bank / ACH</span>
    </label>
  </div>
</template>

<script>
export default {
  data () {
    return {
      credit_card: 'CREDIT_CARD',
      ach: 'ACH',
      account_type: this.value,
    }
  },
  props: {
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    setAccountType(account_type) {
      this.account_type = account_type;
      this.$emit('input', this.account_type);
    },
  }
}
</script>

<style scoped>
.pmt-type {
  border:1px solid #aaa;
  border-radius:3px;
  margin-right:10px;
  padding:8px 12px;
  display: inline-block;
  margin-top:0;
}

.pmt-type:hover {
  border-color:#555;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// NewPaymentMethodSelect.vue?497e7bd2